import type { AuditLogEvent } from '../../../domain/audit-log-event'

import { AuditLogAction } from '../../../domain/audit-log-action.enum'
import { AuditLogResourceType } from '../../../domain/audit-log-resource-type.enum'
import * as constants from '../constants'

interface Props {
  auditLog: AuditLogEvent
}

export const CheckRunRerunSummaryColumn = (props: Props): JSX.Element | null => {
  if (
    props.auditLog.resource?.type !== AuditLogResourceType.CheckRun ||
    props.auditLog.action !== AuditLogAction.Rerun
  ) {
    return null
  }

  const summary = {
    dropOffToLin: props.auditLog.resource?.data.dropOffToLin,
    emailNotification: props.auditLog.resource?.data.emailNotification
  }

  return (
    <div className='flex gap-2'>
      {Object.entries(summary).map(([key, value]) => (
        <div key={key}>
          {value ? '✅' : '❌'}{' '}
          {constants.AUDIT_LOG_CHECK_RUN_RERUN_SUMMARY_MAPPER[key as keyof typeof summary]}
        </div>
      ))}
    </div>
  )
}
